import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUpdateStatus = createSelector(
  [(store: RootState) => store.profileDetail.updateStatus],
  (status) => status
);
